import { Link } from "react-router-dom";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

function ordinalSuffix(day) {
  if (day > 3 && day < 21) return "th";
  switch (day % 10) {
    case 1: return "st";
    case 2: return "nd";
    case 3: return "rd";
    default: return "th";
  }
}

function formatPublishDate(dateStr) {
  if (!dateStr) return null;
  const date = new Date(dateStr);
  if (isNaN(date.getTime())) return null;
  const diffDays = Math.floor((Date.now() - date.getTime()) / (1000 * 60 * 60 * 24));
  if (diffDays < 30) {
    if (diffDays <= 0) return "Today";
    if (diffDays === 1) return "1 day ago";
    return `${diffDays} days ago`;
  }
  return `${date.getDate()}${ordinalSuffix(date.getDate())} ${MONTHS[date.getMonth()]} ${date.getFullYear()}`;
}

export default function ArticleCard({ article, isAdmin }) {
  const dateLabel = formatPublishDate(article.publishDate);
  return (
    <Link to={article.href} style={{ textDecoration: "none", display: "flex", flexDirection: "column" }}>
      <div style={{ height: 190, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <img
          src={article.img}
          alt={article.title}
          style={{ width: "100%", height: "100%", objectFit: "cover", display: "block", transition: "transform 0.4s ease" }}
          onMouseEnter={e => e.currentTarget.style.transform = "scale(1.04)"}
          onMouseLeave={e => e.currentTarget.style.transform = "scale(1)"}
        />
      </div>
      <div style={{ marginBottom: 8, display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#888" }}>{article.tag}</span>
        {dateLabel && <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#888" }}>· {dateLabel}</span>}
        {isAdmin && article.viewCount != null && (
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", color: "#4A6DC7" }}>· {article.viewCount} {article.viewCount === 1 ? "view" : "views"}</span>
        )}
      </div>
      <h3 style={{ fontFamily: "'Inter', sans-serif", fontWeight: 600, fontSize: 15, color: "#1A1A1A", lineHeight: 1.4, marginTop: 0, marginBottom: 6 }}>{article.title}</h3>
      <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "#666", lineHeight: 1.65, margin: 0 }}>{article.desc}</p>
    </Link>
  );
}